import LanguageControl from 'mapbox-gl-controls/lib/language';

const control = new LanguageControl({
  language: window.currentLanguage,
  supportedLanguages: ['uk', 'ru'],
  // в этом методе определяется основное свойство для надписи на выбранном языке,
  // fallback-свойство (напр. 'name') дополнительно указывается в самом json-стиле
  // карты, напр.
  // ```
  // "text-field": ["coalesce", ["get", "name:uk"], ["get", "name"]],
  // ```
  getLanguageField: (lang) => `name:${lang}`,
});

export default control;
